import { DbrBalloonEntity } from '@balloon-race-fullstack-monorepo/dbr-rest-api';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace BalloonsStateActions {
  export class SetBalloons {
    static readonly type = '[Balloons] SetBalloons';

    constructor(public balloons: DbrBalloonEntity[]) {
    }
  }

  export class SetActiveBalloonCode {
    static readonly type = '[Balloons] SetActiveBalloonCode';

    constructor(public balloonCode: string) {
    }
  }
}
